// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___2n51X","text":"text___Bs-Sf","size":"size___3_1JX"};